import classes from './LoadingTable.module.scss'

const LoadingTable = (props) => {
    return (
        <div style={props.style} className={classes.container}>
            <div className={classes.spinner}><div></div><div></div><div></div></div>
        </div>
    )
}

export default LoadingTable